import { Box, Grid2, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DEFAULT_PAPER_STYLE = {};

function BlockWithTitle({
    children,
    title,
    paperStyle = DEFAULT_PAPER_STYLE,
    headerRight,
    subHeader,
    collapsible,
}) {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <Paper sx={{ p: 2 }} style={paperStyle}>
            <Grid2 container spacing={2} style={{ position: 'relative' }}>
                {(title || headerRight) && (
                    <Grid2
                        size={{ xs: 12 }}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: 1,
                            pb: (!collapsible || !collapsed) && subHeader ? 0 : undefined,
                            cursor: collapsible ? 'pointer' : undefined,
                            userSelect: collapsible ? 'none' : undefined,
                        }}
                        onClick={collapsible ? () => setCollapsed((prev) => !prev) : undefined}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                minWidth: 0,
                            }}
                        >
                            {title && (
                                <Typography
                                    variant="subtitle1"
                                    sx={{ textAlign: 'left', fontWeight: 600 }}
                                >
                                    {title}
                                </Typography>
                            )}
                            {collapsible && (
                                <ExpandMoreIcon
                                    sx={{
                                        flexShrink: 0,
                                        transition: 'transform 0.2s',
                                        transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                                    }}
                                />
                            )}
                        </Box>
                        {headerRight && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    flexWrap: 'nowrap',
                                    flexShrink: 0,
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {headerRight}
                            </Box>
                        )}
                    </Grid2>
                )}
                {(!collapsible || !collapsed) && (
                    <>
                        {subHeader && (
                            <Grid2 size={{ xs: 12 }} sx={{ mt: -1.5, pb: 0.5, textAlign: 'left' }}>
                                {subHeader}
                            </Grid2>
                        )}
                        {children}
                    </>
                )}
            </Grid2>
        </Paper>
    );
}

export default BlockWithTitle;
